import { useChangeSalesManagementStatusByApprover } from "@/shared/api";
import CommonError from "@/shared/api/CommonError";
import { useModal, vars } from "@/shared/lib";
import { SALES_STATUS, SALES_STATUS_KEY_TYPE } from "@/shared/model";
import { Button, Center, Column, Indicator, Typography } from "@/shared/ui";
import { createFileRoute } from "@tanstack/react-router";
import { useMount } from "react-use";

type SalesManagementChangeDeeplinkSearch = {
	t: string; // token
	s: SALES_STATUS_KEY_TYPE; // 변경할 status
	smid: string; // salesManagementId
};

export const Route = createFileRoute("/(non-auth)/deeplink/sales-management-change")({
	component: SalesManagementChange,
	validateSearch: (search: Record<string, unknown>): SalesManagementChangeDeeplinkSearch => {
		return {
			t: (search.t as string) ?? "",
			s: (search.s as SALES_STATUS_KEY_TYPE) ?? "DEFAULT",
			smid: (search.smid as SALES_STATUS_KEY_TYPE) ?? ""
		};
	}
});

/**
 * @returns t=token&s=상태&smid=salesmanagementId
 */

function SalesManagementChange() {
	const { openModal } = useModal();
	const search = Route.useSearch();

	const { mutate } = useChangeSalesManagementStatusByApprover();

	useMount(() => {
		if (!search.t || search.s === "DEFAULT" || !search.smid) {
			openModal(<ResponseModal text="잘못된 경로입니다" />);
		} else {
			mutate(
				{ salesManagementId: search.smid, status: search.s, token: search.t },
				{
					onSuccess: (_, variables) => {
						openModal(<ResponseModal text={`${SALES_STATUS[variables.status]}이/가 완료되었습니다.`} />);
					},
					onError: (error) => {
						const axiosError = error as CommonError;
						const errorMessage = axiosError.message ?? "";
						console.error(axiosError.message);

						let modalMessage = "일시적인 오류 입니다. \n 관리자에게 문의하세요.";

						if (errorMessage === "already approved") {
							modalMessage = "이미 승인된 요청입니다";
						} else if (errorMessage === "already rejected") {
							modalMessage = "이미 반려된 요청입니다";
						} else if (errorMessage === "first approver not approved yet") {
							modalMessage = "1차 승인이 완료되지 않았습니다";
						} else if (errorMessage === "Full authentication is required to access this resource") {
							modalMessage = "접근할 수 없는 토큰입니다";
						}

						openModal(<ResponseModal text={modalMessage} />);
					}
				}
			);
		}
	});

	return (
		<Center
			style={{
				width: "100%",
				height: "100vh",

				backgroundColor: vars.color.gray[50]
			}}
		>
			<Indicator />
		</Center>
	);
}

function ResponseModal({ text }: { text: string }) {
	const onClick = () => {
		const os = window.navigator.userAgent || window.navigator.vendor;

		if (os.toLocaleLowerCase().indexOf("android") > -1) {
			location.href = "kakaotalk://inappbrowser/close";
		} else if (os.toLocaleLowerCase().indexOf("iphone") > -1 || os.toLocaleLowerCase().indexOf("ipad") > -1) {
			location.href = "kakaoweb://closeBrowser";
		} else {
			self.close();
		}
	};

	return (
		<Column fullWidth style={{ padding: "18px 32px 12px", gap: vars.size[18], justifyContent: "space-between" }}>
			<Typography size="18px">{text}</Typography>
			<Button size="medium" onClick={onClick}>
				{"확인"}
			</Button>
		</Column>
	);
}